import { CompositeDecorator } from "draft-js";
import decorators from "./defaultDecorators";

export default new CompositeDecorator(Object.values(decorators));
